/*
 Licensed Materials - Property of IBM
 5737-I23
 Copyright IBM Corp. 2019. All Rights Reserved.
 U.S. Government Users Restricted Rights:
 Use, duplication or disclosure restricted by GSA ADP Schedule
 Contract with IBM Corp.
 */
import React from 'react';


function CustomObjectFieldTemplate(props) {
    const { TitleField, DescriptionField } = props;

    const mountTitleField = () => {
        if (props.uiSchema['ui:title'] || props.schema.title) {
            return (
                <TitleField
                    id={`${props.idSchema.$id}__title`}
                    title={props.schema.title || props.uiSchema['ui:title']}
                    required={props.required}
                    formContext={props.formContext}
                />
            );
        }
    };

    const mountDescriptionField = () => {
        if (props.uiSchema['ui:description'] || props.schema.description) {
            return (
                <DescriptionField
                    id={`${props.idSchema.$id}__description`}
                    description={props.uiSchema['ui:description'] || props.schema.description}
                    formContext={props.formContext}
                />
            );
        }
    };

    const titleField = mountTitleField();
    const descriptionField = mountDescriptionField();

    const className = props.idSchema.$id === 'root' ? 'baiw--form-common-root' : '';
    return (
        <div className={className}>
            {(titleField || descriptionField) && (
                <div id={`${props.idSchema.$id}__info`} className={'bx--fieldset baiw--title-container'}>
                    {titleField}
                    {descriptionField}
                </div>
            )}
            {props.properties.map(prop => prop.content)}
        </div>
    );
}//

export { CustomObjectFieldTemplate };